import type { RawAlarmRequest, RawAlarmResponse } from '@heviton/heviton-api-app-legacy';
import type { AlarmItem } from '@/shared/data-types';

/**
 * BE `RawAlarmResponse` → FE `AlarmItem[]`. **순수 변환** — 검증·throw 없음.
 * wire 어휘(`alarmTypeCode`/`alarmDetailTypeCode`/`isAlarm`)는 매퍼 내부에만 등장.
 */
export function fromRawAlarm(raw: RawAlarmResponse): AlarmItem[] {
  return (raw.alarms ?? []).map((item) => ({
    alarmType: item.alarmTypeCode,
    channel: item.alarmDetailTypeCode,
    enabled: item.isAlarm,
  }));
}

/**
 * FE `AlarmItem[]` → BE `RawAlarmRequest` (PUT body). 서버가 준 전체 목록을 그대로 되돌려보내며
 * 토글된 항목의 `enabled` 만 반영 — 미노출 항목도 보존(feature 가 전체 배열을 넘긴다).
 */
export function toRawAlarm(items: AlarmItem[]): RawAlarmRequest {
  return {
    alarms: items.map((item) => ({
      alarmTypeCode: item.alarmType,
      alarmDetailTypeCode: item.channel,
      isAlarm: item.enabled,
    })),
  };
}
